import { Logger } from 'vue-infra';
import { BAM_EVENT_NAME_TYPES, BAM_TRIGGER_SOURCE } from './BamConsts';
import sendBam from './sendBam';

const logger = Logger.getLogger('transcriptWidget');
const widgetName = 'transcript';

const BAM_TRANSCRIPT_WIDGET_ACTION_CONTEXT = {
  CONVERSATIONS: 'conversations',
};

export function sendOpenCloseBAM(isOpen) {
  const action = isOpen ? BAM_EVENT_NAME_TYPES.OPEN : BAM_EVENT_NAME_TYPES.HIDE;
  sendBam(logger, {
    widgetName,
    eventName: action,
    userAction: action,
    userActionContext: BAM_TRANSCRIPT_WIDGET_ACTION_CONTEXT.CONVERSATIONS,
    targetSource: BAM_TRIGGER_SOURCE.TRANSCRIPT_SWITCH,
  });
}

export function sendViewInAgentWSBAM(convId) {
  sendBam(logger, {
    widgetName,
    eventName: BAM_EVENT_NAME_TYPES.VIEW_IN_AGENT_WORKSPACE,
    userActionContext: BAM_TRANSCRIPT_WIDGET_ACTION_CONTEXT.CONVERSATIONS,
    targetSource: BAM_TRIGGER_SOURCE.TRANSCRIPT_FOOTER,
    value: convId,
  });
}

export function sendNewMessagesBAM(convId) {
  sendBam(logger, {
    widgetName,
    eventName: BAM_EVENT_NAME_TYPES.TRANSCRIPT_NEW_MESSAGES,
    userActionContext: BAM_TRANSCRIPT_WIDGET_ACTION_CONTEXT.CONVERSATIONS,
    targetSource: BAM_TRIGGER_SOURCE.TRANSCRIPT_FOOTER,
    value: convId,
  });
}

export function sendNewMessagesPopupBAM(convId) {
  sendBam(logger, {
    widgetName,
    eventName: BAM_EVENT_NAME_TYPES.TRANSCRIPT_NEW_MESSAGES_POPUP,
    userActionContext: BAM_TRANSCRIPT_WIDGET_ACTION_CONTEXT.CONVERSATIONS,
    targetSource: BAM_TRIGGER_SOURCE.TRANSCRIPT_NEW_MESSAGES_POPUP,
    value: convId,
  });
}

export function sendErrorBAM(convId, error) {
  sendBam(logger, {
    widgetName,
    eventName: BAM_EVENT_NAME_TYPES.ERROR_HANDLING,
    userAction: BAM_EVENT_NAME_TYPES.SELECT,
    userActionContext: `Transcript Error :: ${error}`,
    targetSource: BAM_TRIGGER_SOURCE.TRANSCRIPT_ERROR,
    value: convId,
  });
}

export function sendSelectConversationBAM(convId) {
  sendBam(logger, {
    widgetName,
    eventName: BAM_EVENT_NAME_TYPES.SELECT,
    userAction: BAM_EVENT_NAME_TYPES.SELECT,
    userActionContext: BAM_TRANSCRIPT_WIDGET_ACTION_CONTEXT.CONVERSATIONS,
    targetSource: BAM_TRIGGER_SOURCE.TABLE_ROW,
    value: convId,
  });
}
